import { render, staticRenderFns } from "./guestCard.vue?vue&type=template&id=253921e4&scoped=true&"
import script from "./guestCard.vue?vue&type=script&lang=js&"
export * from "./guestCard.vue?vue&type=script&lang=js&"
import style0 from "./guestCard.vue?vue&type=style&index=0&id=253921e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253921e4",
  null
  
)

export default component.exports